import type { ConversationNodeVoicemail } from 'lib-shared-types-api';

type Props = {
  node: ConversationNodeVoicemail;
};

export function RoutedThroughVoicemail({ node }: Props): JSX.Element {
  return (
    <>
      Voicemail · Added to queue <strong>{node.queue}</strong>
    </>
  );
}
